import { FC, useState, useEffect } from 'react';
import { Box, Image as ChakraImage } from '@chakra-ui/react';

const DemoAssistantLogo: FC<{
	src?: string;
	size?: { h: number; w: number };
	onLoad?: () => void;
}> = ({ src, size = { h: 10, w: 10 }, onLoad }) => {
	const [isLoaded, setIsLoaded] = useState(false);

	useEffect(() => {
		if (!src) return;

		const img = new Image();
		img.src = src;

		img.onload = () => {
			setIsLoaded(true);
			onLoad && onLoad();
		};

		return () => {
			img.onload = null;
		};
	}, [src]);

	return (
		<Box
			position="relative"
			height={size.h}
			width={size.w}
			// Hack for Quest logo
			borderRadius={
				src ===
				'https://storage.googleapis.com/fusion-cloud-ai-static/static-assets/logo-quest%201.png'
					? '0'
					: 'full'
			}
			overflow="hidden"
			alignContent="center"
		>
			<ChakraImage
				src={src}
				alt="Demo User Logo"
				maxHeight={size.h}
				maxWidth={size.w}
				borderRadius="full"
				objectFit="cover"
				visibility={isLoaded ? 'visible' : 'hidden'}
			/>
		</Box>
	);
};

export default DemoAssistantLogo;
